import { Outlet } from "react-router-dom";

import { Loading } from "@/components/_molecules/loading-view";
import { Navigate } from "@/components/_molecules/navigation-controls/navigate";
import { useCanManageWorkspace } from "@/domain/workspace/hooks/use-can-manage-workspace";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";
import { makeSettingsUrl } from "@/domain/workspace/lib/make-workspace-url";

export function WorkspaceAdminRoute(): JSX.Element {
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { canManageWorkspace, loading } = useCanManageWorkspace({ workspaceId: currentWorkspace.id });

  if (loading) {
    return <Loading />;
  }

  if (!canManageWorkspace) {
    return <Navigate to={makeSettingsUrl({ workspace: currentWorkspace, path: "account" })} replace />;
  }

  return <Outlet />;
}
